import { version } from '../../package.json'

export const VersionBadge = () => {
  const appEnvironment = import.meta.env.VITE_APP_ENVIRONMENT || 'development'

  if (!['local', 'development', 'staging'].includes(appEnvironment)) {
    return null
  }

  const getEnvironmentStyles = () => {
    switch (appEnvironment) {
      case 'local':
        return 'text-[#AA50A1] border-[#AA50A1]'
      case 'development':
        return 'text-[#6950A1] border-[#6950A1]'
      case 'staging':
        return 'text-[#ffa500] border-[#ffa500]'
      default:
        return 'text-[#6950A1] border-[#6950A1]'
    }
  }

  return (
    <div
      className={`fixed bottom-5 right-5 px-3 py-2 rounded text-sm font-medium bg-white/90 shadow-sm z-50 border-2 ${getEnvironmentStyles()}`}
    >
      env: {appEnvironment} | v{version}
    </div>
  )
}
